import {Link} from "react-router-dom";

export const RouterLink = Link;
